<template>
    <div>
		<div class="row">
			<div class="col-md-12 p-0">
				<el-card class="box-card col-md-12 mb-4" :body-style="{ paddingLeft: '0px', paddingRight: '0px' }">
					<div slot="header" class="clearfix">
						<span><strong>BUSINESS FUEL TRACKING</strong></span>
					</div>
					<div>
						<div class="mb-3" style="margin-top: -21px;">   
							<el-tabs type="border-card" v-model="tabIndex" @tab-click="handleTabClick">
								<el-tab-pane :label="'Console'" :name="'0'">
									<FuelTrackingConsole :tabIndex="'0'" :tabName="'console'" :tabLabel="'Consol'" :showchartconsole="showchartconsole"/>
								</el-tab-pane>
								<el-tab-pane :label="'By Sales Area'" :name="'1'">
									<FuelTrackingBySalesArea :tabIndex="'1'" :tabName="'by_sales_area'" :tabLabel="'By Sales Area'" :showchartbyareakomposisi="showchartbyareakomposisi" :showchartbyareagrowth="showchartbyareagrowth"/>
								</el-tab-pane>
								<el-tab-pane :label="'Report'" :name="'2'">
									<FuelTrackingReport :tabIndex="'2'" :tabName="'fuel_report'" :tabLabel="'Report'"/>
								</el-tab-pane>
							</el-tabs>
						</div>
					</div>
				</el-card>	
			</div>
		</div>
	</div>
</template>

<script>
import Fuel from '@/components/page/Fuel.js'
//import ReportParamSelect from '@/views/pages/ReportParamSelect.vue'
import ReportResultTable from '@/views/pages/ReportResultTable2.vue'
import { Rainbow, FuelColor, Config, Penanggalan, AxiosWithJar } from '@/utility.js'
//import Loader from '@/components/loader/Loader.vue'
import LineChart from '@/components/chart/LineChart.js'
import BarChart from '@/components/chart/BarChart.js'
import FuelTrackingConsole from '@/views/pages/FuelTracking/FuelTrackingConsole.vue'
import FuelTrackingBySalesArea from '@/views/pages/FuelTracking/FuelTrackingBySalesArea.vue'
import FuelTrackingReport from '@/views/pages/FuelTracking/FuelTrackingReport.vue'


export default
{
	extends: Fuel,
	components: { 
		FuelTrackingReport,
		FuelTrackingConsole,
		FuelTrackingBySalesArea,
	},

	data(){
		return {
			showchartbyareakomposisi: false,
			showchartbyareagrowth: false,
			showchartconsole: false,

			tabIndex: this.$route.query.tab ? this.$route.query.tab : '0', 
			/*
			tabList:[
				{label:'Sales', name: 'sales', index: '0' },
				{label:'Losses', name: 'losses', index: '1' },
			],
            */
		}
	},
	watch:
	{
		//area() { this.resumePilihan() },
	}, 
    mounted()
    {
        this.$emit('childrenRoute');
    },
    methods:{
		handleTabClick(tab, event) {
            let tabIndex = tab.$vnode.key
            let tabName = tab.name
            let tabLabel = tab.label
			/*
            this.tab.index = tabIndex
            this.tab.name = tabName
            this.tab.label = tabLabel
			*/

			//console.log('show chart area')
			//this.idfornitore = true; // mutating props directly will result in vuejs warning. i have used this code here to show how this works.
			//this.$emit("changevalue",this.idfornitore);
			//this.$emit('drawChartByySalesArea');
			if(tabName == '0') {
				this.showchartconsole = false
				setTimeout(() => {
					this.showchartconsole = true
				}, 1000);
			} else if(tabName == '1') {
				this.showchartbyareakomposisi = false
				this.showchartbyareagrowth = false

				setTimeout(() => {
					this.showchartbyareakomposisi = true
					this.showchartbyareagrowth = true
				}, 1000);
			}
        },

    }
}
</script>

<style scoped>

</style>